import type { AssetRecord } from "../graph/buildAssetDocsGraph";
import { ASSET_KEY_FIELD, ASSET_REPORT_TYPES } from "./assetReportTypes";

const ASSET_LABEL_FIELDS = ["UnitName", "UnitAbbreviation", "PlantName"];

interface AssetHit {
    _source?: Record<string, unknown>;
}

const asText = (value: unknown): string =>
    typeof value === "string" || typeof value === "number" ? String(value) : "";

const asCount = (value: unknown): number => (typeof value === "number" ? value : 0);

export const toAssetRecords = (body: unknown): AssetRecord[] => {
    const hits = (body as { hits?: { hits?: AssetHit[] } })?.hits?.hits ?? [];
    return hits.flatMap((hit) => {
        const source = hit._source ?? {};
        const id = asText(source[ASSET_KEY_FIELD]);
        if (!id) return [];
        const label = ASSET_LABEL_FIELDS.map((field) => asText(source[field])).find(Boolean) ?? id;
        return [
            {
                id,
                label,
                counts: Object.fromEntries(
                    ASSET_REPORT_TYPES.map((report) => [
                        report.countField,
                        asCount(source[report.countField]),
                    ]),
                ),
            },
        ];
    });
};
